export * from './calculator';

export const pushStateToSessionStorage = () => {
  return (dispatch, getState) => {
    let state = getState();
    let str = JSON.stringify(state);
    sessionStorage.setItem('redux_state_snapshot', str);
  }
};

export const REPLACE_STATE = 'REPLACE_STATE';
export const popStateFromSessionStorage = () => {
  return (dispatch, getState) => {
    let str = sessionStorage.getItem('redux_state_snapshot');
    if(str) {
      let state = JSON.parse(str);
      dispatch({
        type: REPLACE_STATE,
        payload: state
      });
      sessionStorage.removeItem('redux_state_snapshot');
    } else {
      console.error('no state stored in session storage');
    }
  }
};


// WEBPACK FOOTER //
// ./src/actions/index.js